const $document = $(document);
$document.on('click', '[data-tab-content-toggle]', function () {
  $(this).closest('[data-tab-content]').find('[data-tab-content-section]').toggleClass('hide');
});
$document.on('click', '[data-tab-content-open]', function () {
  const $self = $($(this).attr('data-tab-content-open') || this).closest('[data-tab-content]');
  if ($self.find('[data-tab-content-section]').length > 1) {
    $self.find('[data-tab-content-section]').removeClass('hide');
    $self.find('[data-tab-content-section]:first').addClass('hide');
  }
});

(() => {
  let currentTop = -1000;
  let $header;
  let offset;

  function getOffset() {
    return $('.shopheader-mobile').is(':visible') ? 47 : 184;
  }

  function render() {
    if (offset === undefined) {
      offset = getOffset();
    }
    let top = Math.min($document.scrollTop() - (600 - offset), offset);
    if (top < offset - 85) {
      top = -1000;
    }
    if (currentTop !== top) {
      currentTop = top;
      if ($header === undefined) {
        $header = $('[data-item-fixed-header]');
      }
      $header.css('top', `${top}px`);
    }
  }

  function calculateOffset() {
    const newOffset = getOffset();
    if (newOffset !== offset) {
      offset = newOffset;
      render();
    }
    return offset;
  }

  $(window).on('resize', calculateOffset);
  $document.on('scroll', render);
  $(render);
})();
